<template>
  <span>
    <i
      v-if="fileExtention == 'xlsx'"
      :class="'iconFile ' + 'color__green ' + 'fas ' + 'fa-file-excel ' + customClass"
    ></i>
    <i
      v-else-if="fileExtention == 'png'"
      :class="'iconFile ' + 'color__yellow ' + 'fas ' + 'fa-file-image ' + customClass"
    ></i>
    <i
      v-else-if="fileExtention == 'pdf'"
      :class="'iconFile ' + 'color__red ' + 'fas ' + 'fa-file-pdf ' + customClass"
    ></i>
    <i
      v-else-if="fileExtention == 'docx'"
      :class="'iconFile ' + 'color__blue ' + 'fas ' + 'fa-file-word ' + customClass"
    >

    </i>
    <i
      v-else
      :class="'iconFile ' + 'color__smoke ' + 'fas ' + 'fa-file ' + customClass"
    ></i>
  </span>
</template>
<script>
export default {
  name: 'fileTypeImage',
  props: ["fileExtention", "customClass"]
}
</script>



// WEBPACK FOOTER //
// src/views/job/FileTypeImage.vue